import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Link } from "gatsby"
import { motion } from "framer-motion"

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: fit-content;
  position: relative;
  > p {
    margin-bottom: 50px;
    font-size: 2.4rem;
  }
`

const Header = styled.button`
  color: currentColor;
  border: none;
  background: none;
`

const Title = styled.div`
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  color: currentColor;
`

const List = styled(motion.div)`
  background-color: #fff;
  box-shadow: 10px 10px 35px rgba(0, 0, 0, 0.05);
  position: absolute;
  top: 35px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
`

const Item = styled(Link)`
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  gap: 4px;
  color: #000;
  text-decoration: none;
  transition: background-color 0.25s ease-in-out, font-weight 0.25s ease-in-out;

  &:hover {
    background-color: #f3f4f6;
  }
`

const innerVariants = {
  open: { opacity: 1, display: "block" },
  closed: { opacity: 0, transitionEnd: { display: "none" } },
}

const Dropdown = ({ title, list }) => {
  const [show, setShow] = React.useState(false)
  const listRef = React.useRef(null)

  /**
   * Close when clicking outside
   */
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (listRef.current && !listRef.current.contains(event.target)) {
        setShow(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [listRef, setShow])

  return (
    <Wrapper>
      <Header
        role="button"
        tabIndex="0"
        onClick={e => {
          setShow(true)
        }}
      >
        <Title>{title}</Title>
      </Header>
      <List
        animate={show ? "open" : "closed"}
        ref={listRef}
        variants={innerVariants}
        transition={{ duration: 0.6 }}
        initial={false}
      >
        {list.map((item, i) => {
          return (
            <Item key={i} to={item.to} onClick={item.onClick}>
              {item.title}
              <small>{item.description}</small>
            </Item>
          )
        })}
      </List>
    </Wrapper>
  )
}

Dropdown.propTypes = {
  title: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      to: PropTypes.string,
      onClick: PropTypes.func,
    })
  ),
}

export { Dropdown }
